import { getOrCreatePulse } from './utils';

export const viewTrackingAction = (userId?: string): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'View',
    object: {
      '@type': 'Account',
      '@id': 'sdrn:subito:user:public_profile',
      name: 'Profilo - Subito.it',
      accountId: `sdrn:subito.it:user:${userId ?? null}`,
    },
  });
};

export const previewReviewClickAction = (ownerId: string): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'Click',
    name: 'review',
    object: {
      '@type': 'UIElement',
      '@id': 'sdrn:subito:content:rating_profile:element:click_textual_review',
      label: 'click testo review',
    },
    target: {
      '@id': `sdrn:subito:user:${ownerId}`,
      '@type': 'Account',
    },
  });
};

export const viewReviewModalAction = (ownerId: string): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'View',
    name: 'review',
    object: {
      '@type': 'UIElement',
      '@id': 'sdrn:subito:content:rating_profile:element:view_textual_review',
      label: 'view testo review',
    },
    target: {
      '@id': `sdrn:subito:user:${ownerId}`,
      '@type': 'Account',
    },
  });
};

export const reviewCountClickAction = (ownerId: string): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'Click',
    name: 'review',
    object: {
      '@type': 'UIElement',
      '@id': 'sdrn:subito:content:rating_profile:element:click_textual_review',
      label: 'click numero di recensioni',
    },
    target: {
      '@id': `sdrn:subito:user:${ownerId}`,
      '@type': 'Account',
    },
  });
};

export const reviewerNameClickAction = (userId: string): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'Click',
    name: 'review',
    object: {
      '@type': 'UIElement',
      '@id':
        'sdrn:subito:content:rating_profile:element:click_textual_review_name',
      label: 'click nome recensore',
    },
    target: {
      '@id': `sdrn:subito:user:${userId}`,
      '@type': 'Account',
    },
  });
};
